var map = {
	"./acb.png": 2681,
	"./aire2-jeu.jpg": 5704,
	"./aramex.gif": 1009,
	"./assises-sect-electricite.png": 2244,
	"./bank-of-africa.png": 9913,
	"./banque-mondial.jpg": 9589,
	"./bcdc.png": 5063,
	"./bracongo.png": 8993,
	"./bureau-veritas.jpg": 8334,
	"./canal+.png": 7179,
	"./colex.jpg": 113,
	"./d.jpg": 1456,
	"./egalite-des-sex-conf.jpg": 1012,
	"./fec.png": 198,
	"./fest-rumba.png": 8846,
	"./forum-ener-electrique-rdc.png": 5888,
	"./gecotrans.png": 6179,
	"./glencore.jpg": 7322,
	"./heineken.jpg": 8969,
	"./hotel-invest.png": 9197,
	"./influence.jpg": 6522,
	"./josepha-cos.png": 759,
	"./kin-jazz.png": 5886,
	"./kin-magic.jpg": 833,
	"./la-cle-chateau.png": 5392,
	"./level-up.png": 5747,
	"./liege-universite.png": 8584,
	"./m-pesa.png": 2824,
	"./majestic-river.png": 9125,
	"./makutano.jpg": 4562,
	"./optimum.png": 9493,
	"./org-int-travail.png": 2730,
	"./peuple-dabor.png": 7801,
	"./pullman.png": 8810,
	"./rdc-africa-business.jpg": 4225,
	"./rochas-event.png": 9253,
	"./room-for-innov.png": 8776,
	"./sayanza.jpg": 3431,
	"./seedstars.png": 6736,
	"./standard-bank.png": 2063,
	"./ucm.png": 2985,
	"./vlisco.png": 2439,
	"./vod-ligue1.png": 192,
	"./vodacom.png": 7020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7088;